import { render, staticRenderFns } from "./SearchResultsTable.vue?vue&type=template&id=f75ed8fc&"
import script from "./SearchResultsTable.vue?vue&type=script&lang=js&"
export * from "./SearchResultsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports